import React from 'react';

function Contact() {
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      <p>We'd love to hear from you! Reach out with questions, feedback, or just to say hello.</p>

      <div className="contact-methods">
        <div className="contact-card">
          <div className="icon">📍</div>
          <h3>Visit Us</h3>
          <p>
            9410 W Sahara Ave Ste 130<br />
            Las Vegas, NV 89117
          </p>
        </div>

        <div className="contact-card">
          <div className="icon">📞</div>
          <h3>Call Us</h3>
          <p>
            <a href="tel:+17024629252">(702) 462-9252</a>
          </p>
        </div>

        <div className="contact-card">
          <div className="icon">✉️</div>
          <h3>Email Us</h3>
          <p>
            <a href="mailto:support@littleavalon.com">support@littleavalon.com</a>
          </p>
        </div>
      </div>

      <div className="contact-card" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div className="icon">🕐</div>
        <h3>Hours of Operation</h3>
        <p>
          <strong>Monday - Thursday:</strong> 8:00 AM - 9:00 PM<br />
          <strong>Friday - Saturday:</strong> 8:00 AM - 10:00 PM<br />
          <strong>Sunday:</strong> 9:00 AM - 8:00 PM
        </p>
      </div>

      <div style={{ marginTop: '3rem', textAlign: 'center' }}>
        <h2 style={{ marginBottom: '1rem', color: '#2D2D2D' }}>App Support</h2>
        <p style={{ color: '#6C757D', maxWidth: '600px', margin: '0 auto' }}>
          Having trouble with the Little Avalon app? We're here to help! For technical issues, 
          order problems, or account questions, please email us at{' '}
          <a href="mailto:support@littleavalon.com" style={{ color: '#4A9B7F', fontWeight: 600 }}>
            support@littleavalon.com
          </a>{' '}
          or call during business hours.
        </p>
      </div>
    </div>
  );
}

export default Contact;
